import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { releaseNotesData } from '@/components/organism/ReleaseNotes/release-notes-content/data';

import packageInfo from '../../../../package.json';
import ReleaseNotes from '../ReleaseNotes/ReleaseNotes';

const serviceInfoTitle = 'Fleet Assistant';
const serviceInfoVersion = packageInfo.version;

const whatsNewSeenLocalStorage = 'whatsNewSeen';
const WHATS_NEW_VERSION = releaseNotesData.version;

const ServiceInfo = () => {
  const intl = useIntl();
  const [isOpen, setOpen] = useState(false);

  const handleShowReleaseNotes = () => {
    setOpen(true);
    document.querySelector('.modal')?.classList.toggle('show');
  };
  const handleCloseReleaseNotes = () => {
    setOpen(false);
    document.querySelector('.modal')?.classList.toggle('show');
    localStorage.setItem(whatsNewSeenLocalStorage, WHATS_NEW_VERSION);
  };

  useEffect(() => {
    const seenVersion = localStorage.getItem(whatsNewSeenLocalStorage);

    if (seenVersion !== WHATS_NEW_VERSION) {
      setOpen(true);
    }
  }, []);

  return (
    <ActionBarItem id="serviceInfo" className="myItem">
      <ReleaseNotes isOpen={isOpen} onClose={handleCloseReleaseNotes} />
      <ActionBarItem.Icon>
        <span className="icon rioglyph rioglyph-info-sign" />
      </ActionBarItem.Icon>
      <ActionBarItem.Popover className="margin-left-10">
        <ActionBarItem.List>
          <div className="margin-bottom-10">
            <span>{serviceInfoTitle}</span>
            <span className="text-color-gray margin-left-10">{serviceInfoVersion}</span>
          </div>
          <ActionBarItem.ListItem icon="rioglyph-hand-right" onClick={handleShowReleaseNotes}>
            {intl.formatMessage({ id: 'releaseNotes.serviceInfo.title' })}
          </ActionBarItem.ListItem>
        </ActionBarItem.List>
      </ActionBarItem.Popover>
    </ActionBarItem>
  );
};

export default ServiceInfo;
